import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const categories = [
  { key: 'movie', label: '电影', slug: 'dianying', icon: 'ri-movie-line' },
  { key: 'tv', label: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line' },
  { key: 'variety', label: '综艺', slug: 'zongyi', icon: 'ri-live-line' },
  { key: 'anime', label: '动漫', slug: 'dongman', icon: 'ri-rocket-line' },
  { key: 'documentary', label: '纪录片', slug: 'jilupian', icon: 'ri-earth-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline group"
          >
            <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-110">
              <i className="ri-movie-2-fill text-xl text-white"></i>
            </span>
            <span className="text-xl font-heading font-bold tracking-wide whitespace-nowrap">
              午马影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
            <div className="flex flex-col py-2 px-2">
              <Link
                to="/"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === '/'
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {cat.label}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === '/about'
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}